/* eslint-disable max-len */
/* eslint-disable consistent-return */
import React, { useState } from 'react';

const MappingData = (props) => {
  const [showRooms, setShowRooms] = useState(true);
  const [showRateplans, setShowRateplans] = useState(false);

  const { channelConfigData } = props;
  const { mappedArray, pmsArray } = channelConfigData;

  const renderRooms = () => {
    if (Object.keys(mappedArray.categories).length > 0) {
      return Object.keys(mappedArray.categories).map(id => {
        const data = mappedArray.categories[id];
        if (typeof pmsArray.categories[data.pms_cat_id] !== 'undefined') {
          return (
            <div key={`${id}-${data.pms_cat_id}`} className="table_row  border_t_1 border_color_1">
              <div className="tabcel align_middle pad10">{data.ota_cat_name}</div>
              <div className="tabcel align_middle pad10">{data.pms_cat_name} ({pmsArray.categories[data.pms_cat_id].pms_cat_code})</div>
            </div>
          );
        }
        return null;
      });
    }
    return null;
  };

  const renderMappedRateplan = (pmsRatePlanData) => {
    if (Object.keys(pmsRatePlanData).length > 0) {
      return Object.keys(pmsRatePlanData).map(id => {
        const mappedRatePlandata = pmsRatePlanData[id];
        return (
          <div key={id} className="cover">
            <div className="ovr">{mappedRatePlandata.pms_rate_plan_name}</div>
          </div>
        );
      });
    }
    return null;
  };

  const renderRateplans = (mappedData) => {
    if (typeof mappedData !== 'undefined' && Object.keys(mappedData.rateplans).length > 0) {
      return Object.keys(mappedData.rateplans).map(rp_id => {
        const ratePlanData = mappedData.rateplans[rp_id];
        if (typeof ratePlanData.pms_rate_plan_details !== 'undefined') {
          return (
            <div key={rp_id} className="table_row  border_t_1 border_color_1">
              <div className="tabcel align_middle pad10">{ratePlanData.ota_rateplan_name}</div>
              <div className="tabcel align_middle pad10">
                {renderMappedRateplan(ratePlanData.pms_rate_plan_details)}
              </div>
            </div>
          );
        }
        return null;
      });
    }
    return null;
  };

  const renderRates = () => {
    if (Object.keys(mappedArray.categories).length > 0) {
      return Object.keys(mappedArray.categories).map(id => {
        const data = mappedArray.categories[id];
        if (typeof pmsArray.categories[data.pms_cat_id] !== 'undefined') {
          return (
            <div key={id} className="cover border_all_1 border_color_1 marg_bottom15">
              <div className="ovr fnt16 bld pad10">{data.ota_cat_name}</div>
              <div className="table_col table_fixed">
                <div className="table_row bg2_8">
                  <div className="tabcel align_middle bld pad10">Channel Rates</div>
                  <div className="tabcel align_middle bld pad10">System Rates</div>
                </div>
                {renderRateplans(data)}
              </div>
            </div>
          );
        }
        return null;
      });
    }
    return null;
  };

  const toggleTab = (tabName) => {
    if (tabName === 'showRooms') {
      setShowRooms(true);
      setShowRateplans(false);
    } else if (tabName === 'showRatePlans') {
      setShowRooms(false);
      setShowRateplans(true);
    }
  };

  return (
    <div className="wrapper">
      <div className="cover" id="dataListMainDiv">
        <div className="row">
          <div className="col-xs-12 col-md-10 offset-md-1 marg_bottom15">
            <div className="cover">
              <div className="row gutters-5 fnt16">
                <div className="col-xs-auto">
                  <div className={`ovr pad_top_bot5 pad_lft_rht15 cursor_p ${showRooms ? 'bg3 color1' : 'bg2_5'}`} onClick={() => toggleTab('showRooms')}>Room</div>
                </div>
                <div className="col-xs-auto">
                  <div className={`ovr pad_top_bot5 pad_lft_rht15 cursor_p ${showRateplans ? 'bg3 color1' : 'bg2_5'}`} onClick={() => toggleTab('showRatePlans')}>Rate</div>
                </div>
              </div>
            </div>
            <div className="wrapper">
              {showRooms && (
                <div className="cover" id="rate-plan">
                  <div className="cover border_all_1 border_color_1">
                    <div className="table_col table_fixed">
                      <div className="table_row bg2_8">
                        <div className="tabcel align_middle bld pad10">Channel Room</div>
                        <div className="tabcel align_middle bld pad10">System Room</div>
                      </div>
                      {renderRooms()}
                    </div>
                  </div>
                </div>
              )}
              {showRateplans && (
                <div className="cover" id="rack">
                  {renderRates()}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MappingData;
